import "./screen.scss";

import { throttle } from "lodash";
import memoizeOne from "memoize-one";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import timeoutRates from "../../constants/timeoutRates";
import { immutableRecords, PropTypeShapes } from "../../types";
import windowDimensions from "../../utils/windowDimensions";
import { ContainerContext } from "../container/ContainerContext";

const calcStateObjectForScreen = () => {
  const dimensions = windowDimensions();
  const containerRect = immutableRecords.FlatRectRecord({
    left: 0,
    right: dimensions.width,
    width: dimensions.width,
    top: 0,
    bottom: dimensions.height,
    height: dimensions.height
  });
  return Object.assign({}, dimensions, { containerRect });
};

const getContainerContextValue = memoizeOne((stateContainerRect, paddingLeft, paddingRight) => {
  return {
    containerRect: stateContainerRect,
    paddingLeft: paddingLeft ? paddingLeft : 0,
    paddingRight: paddingRight ? paddingRight : 0
  };
});

export default class Screen extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = calcStateObjectForScreen();
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.throttleUpdateWindowDimensions = throttle(this.updateWindowDimensions, timeoutRates.WINDOW_RESIZE_THROTTLE, {
      leading: true,
      trailing: true
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.throttleUpdateWindowDimensions);
  }

  componentWillUnmount() {
    this.throttleUpdateWindowDimensions.cancel();
    window.removeEventListener("resize", this.throttleUpdateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState(calcStateObjectForScreen);
  }

  render() {
    const containerContextValue = getContainerContextValue(
      this.state.containerRect,
      this.props.paddingLeft,
      this.props.paddingLeft
    );

    return (
      <ContainerContext.Provider value={containerContextValue}>
        {/* <div className="aeonScreen">{this.props.children}</div> */}
        {this.props.children}
      </ContainerContext.Provider>
    );
  }
}

Screen.propTypes = {
  children: PropTypeShapes.elementOrArray.isRequired,
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number
};
